/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AnonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet$Params {
  organizationFhirId: string;
  healthCareServiceFhirId?: string;
  locationFhirId?: string;
  specialityFhirId: string;
}

export function anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet(http: HttpClient, rootUrl: string, params: AnonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('organizationFhirId', params.organizationFhirId, {});
    rb.query('healthCareServiceFhirId', params.healthCareServiceFhirId, {});
    rb.query('locationFhirId', params.locationFhirId, {});
    rb.path('specialityFhirId', params.specialityFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<string>>;
    })
  );
}

anonymousServiceConfirmationEmailBinOrganizationFhirIdSpecialityFhirIdGet.PATH = '/Anonymous/ServiceConfirmationEmailBin/{organizationFhirId}/{specialityFhirId}';
